import React, { Fragment } from 'react';
import axios from 'axios';
import { FormattedMessage } from 'react-intl';
import { ToastContainer, toast } from 'react-toastify';
import { Button, Form, Grid, Header, Segment, Transition } from 'semantic-ui-react';

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
// axios.defaults.crossDomain = true;


export default class NewRequest extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            languages: [],
            language: '',
            documentType: '',
            certificateReason: '',
            docLanguages: [],
            loader: true,
            documentTypeError: false,
            certificateReasonIdError: false
        };
        this.sendDocumentRequest = this.sendDocumentRequest.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.getDocTemplateIdFromDocTypeId = this.getDocTemplateIdFromDocTypeId.bind(this);
        // this.getLanguageName = this.getLanguageName.bind(this);
        this.closeAddRequestMode = this.closeAddRequestMode.bind(this);
        this.getStatusCertificateId = this.getStatusCertificateId.bind(this);
    }

    componentDidMount() {
        this.setState({
            languages: [
                {
                    text: window.$locale === 'en' ? 'B/H/S language' : 'B/H/S jezik',
                    key: 1,
                    value: 1
                },
                {
                    text: window.$locale === 'en' ? 'English language' : 'Engleski jezik',
                    key: 2,
                    value: 2
                },
            ]
        });
    }


    /*
    getLanguageName(id) {
        const { languages } = this.props;
        const selected = languages.find(el => el.id === id);
        if (selected && selected.name) return selected.name;
        return '';
    } */

    getStatusCertificateId() {
        const { documentTypes } = this.props;
        const selected = documentTypes.find(el => el.name === 'Statusna potvrda');
        if (selected && selected.id) return selected.id;
        return '';
    }


    getDocTemplateIdFromDocTypeId(docType) {
        const { documentTemplates } = this.props;
        const selected = documentTemplates.find(el => el.documentType.id === docType);
        if (selected && selected.id) return selected.id;
        return '';
    }

    handleInputChange(event, { name, value }) {
        /* if (name === 'documentType') {
            const { documentLanguages } = this.state;
            const docLanguages = documentLanguages.filter(el =>
                el.documentTemplateId === this.getDocTemplateIdFromDocTypeId(value));
            this.setState({ docLanguages, loader: false });
        } */

        if (name === 'documentType') {
            if (value !== this.getStatusCertificateId()) {
                this.setState({ certificateReason: '' });
            }
        }
        this.setState({
            [name]: value
        });
    }

    sendDocumentRequest(documentTypeId, certificateReasonId, comment, language) {
        if (!documentTypeId) {
            this.setState({
                documentTypeError: true
            });

            toast(<FormattedMessage id="studentDocuments.errInputToast" />);
            return;
        } else if (this.state.documentType === this.getStatusCertificateId() && !certificateReasonId) {
            this.setState({
                certificateReasonIdError: true, documentTypeError: false
            });
            toast(<FormattedMessage id="studentDocuments.errInputToast" />);
            return;
        }
        let docRequest = {};

        if (documentTypeId) docRequest = { ...docRequest, documentTypeId };
        if (certificateReasonId) docRequest = { ...docRequest, certificateReasonId };
        docRequest = { ...docRequest, language: language === 2 ? 'en' : window.$locale === 'hr' ? 'hr' : 'bs' };
        if (comment) docRequest = { ...docRequest, comment };

        axios.post('student-documents/create-request', { ...docRequest })
            .then(res => {
                toast(<FormattedMessage id="studentDocuments.sentRequestToast" />);
                this.props.sendDocumentRequest();
                this.closeAddRequestMode();
            })
            .catch(err => {
                if (err.response.data === 'This document is already in queue!') {
                    toast(<FormattedMessage id="studentDocuments.errSentRequestDuplicateToast" />);
                } else {
                    toast(<FormattedMessage id="studentDocuments.errSentRequestToast" />);
                }

                this.props.activateAddRequest(false);
            });
    }

    closeAddRequestMode() {
        this.props.closeAddRequestMode();
    }

    render() {
        if (this.state.error) return <div>Greška</div>;
        return (
            <div>
                <Fragment>
                    <Segment.Group secondary>
                        {/* <Segment> */}
                        {/*    <Header as="h3"> */}
                        {/*        <FormattedMessage id="studentDocuments.createRequest" /> */}
                        {/*    </Header> */}
                        {/* </Segment> */}
                        <Segment secondary clearing>
                            <Form noValidate>
                                <Form.Group widths="equal">
                                    <Form.Field required>
                                        <label>  <FormattedMessage id="studentDocuments.certificateType" /></label>
                                        <Form.Dropdown
                                            clearable
                                            placeholder={<FormattedMessage id="studentDocuments.selectCertificateType" />}
                                            value={this.state.documentType}
                                            onChange={this.handleInputChange}
                                            name="documentType"
                                            options={this.props.documentTypes}
                                            search
                                            fluid
                                            selection
                                            error={this.state.documentTypeError}
                                        />
                                    </Form.Field>
                                    <Form.Field required>
                                        <label>  <FormattedMessage id="common.language" /></label>
                                        <Form.Dropdown
                                            clearable
                                            placeholder={<FormattedMessage id="studentDocuments.selectLanguage" />}
                                            value={this.state.language}
                                            onChange={this.handleInputChange}
                                            name="language"
                                            options={this.state.languages}
                                            search
                                            fluid
                                            selection
                                        />
                                    </Form.Field>
                                    <Form.Field required disabled={this.state.documentType !== this.getStatusCertificateId()}>
                                        <label>  <FormattedMessage id="studentDocuments.certificateReason" /></label>
                                        <Form.Dropdown
                                            clearable
                                            placeholder={<FormattedMessage id="studentDocuments.selectCertificateReason" />}
                                            value={this.state.certificateReason}
                                            onChange={this.handleInputChange}
                                            name="certificateReason"
                                            options={this.props.certificateReasons}
                                            search
                                            fluid
                                            selection
                                            error={this.state.certificateReasonIdError}
                                        />
                                    </Form.Field>
                                </Form.Group>
                                <Form.Field>
                                    <label>  <FormattedMessage id="studentDocuments.writeComment" /></label>
                                    <FormattedMessage id="studentDocuments.writeComment">
                                        {(msg) => (
                                            <Form.TextArea
                                                placeholder={msg}
                                                rows={1}
                                                value={this.state.comment}
                                                onChange={(e) => this.setState({ comment: e.target.value })}
                                            />)}
                                    </FormattedMessage>
                                </Form.Field>
                                <Button basic="true" color="blue" floated="right" onClick={this.closeAddRequestMode}> <FormattedMessage id="common.cancel" /> </Button>
                                <Button
                                    color="blue"
                                    floated="right"
                                    onClick={
                                        () => {
                                            this.sendDocumentRequest(
                                                this.state.documentType,
                                                this.state.certificateReason,
                                                this.state.comment,
                                                this.state.language
                                            );
                                        }
                                    }
                                >
                                    <FormattedMessage id="studentDocuments.send" />
                                </Button>

                            </Form>
                            {/* <ToastContainer hideProgressBar /> */}
                        </Segment>

                    </Segment.Group>
                </Fragment>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/StudentsCertificateRequest/NewRequest.js